import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { UPDATE_DEALER_CREDENTIALS } from './actionTypes';
import { updateDealerCredentialsSuccessful, updateDealerCredentialsFailed } from './actions';
import { addData } from '../../helpers/fackBackend_Helper';

function* editDealerCredentials({ payload: { data } }) {
    try {
        const response = yield call(addData, '/updateDealerCredentials', data);
        if (response.Status) {
            yield put(updateDealerCredentialsSuccessful(response.Message));
        }
        else {
            yield put(updateDealerCredentialsFailed(response.Message));
        }
    } catch (error) {
        yield put(updateDealerCredentialsFailed(error));
    }
}

export function* watchEditDealerCredentials() {
    yield takeEvery(UPDATE_DEALER_CREDENTIALS, editDealerCredentials)
}

function* addDealerCredentialsSaga() {
    yield all([fork(watchEditDealerCredentials),]);
}

export default addDealerCredentialsSaga;

